import React, { useContext } from 'react';
import MainContext from '../../../contexts/MainContext';
import { ReactComponent as NotificationIcon } from '../../../img/svg/Assets/Notification.svg';

export default function MainPage({
  unreadNotificaitonsCount = 0,
  toggle = () => {},
  setUnreadNotificationsCount = () => {},
  getNotifications = () => {}
}) {
  const context = useContext(MainContext);

  const handleClick = () => {
    toggle();
    setUnreadNotificationsCount(0);
    // if (unreadNotificaitonsCount)
    getNotifications();
    context.setWalletSlide(true);
    context.setCartSlide(true);
  };

  return (
    <div
      onClick={() => handleClick()}
      className="nav-btn2 nav-link notification-icon"
    >
      {unreadNotificaitonsCount > 0 && (
        <div className="notification-count">{unreadNotificaitonsCount}</div>
      )}
      <NotificationIcon />
    </div>
  );
}
